<template>
  <main class="contact" v-if="contact">
    <section class="col-2 tight">
      <div class="mb" v-html="contact.text"></div>
      <div>
        <form v-if="!sent && !loading && !error" class="contact-form">
          <input
            type="text"
            name="name"
            v-model="name"
            placeholder="Name"
            required
          />
          <input
            type="email"
            name="email"
            v-model="email"
            placeholder="E-mail"
            required
          />
          <textarea
            name="message"
            v-model="message"
            rows="8"
            placeholder="Please enter your message"
            required
          ></textarea>
          <button type="button" name="button" @click="sendEmail">Send</button>
        </form>
        <div v-if="sent && !loading && !error">
          Thank you, your email has been sent! We'll be in touch as soon as
          possible.
        </div>
        <div v-if="error && !loading">
          An error occured
        </div>
        <div v-if="loading">
          Sending...
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from "axios";
export default {
  name: "contact",
  metaInfo: {
    title: "- Contact"
  },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      loading: false,
      sent: false,
      error: false
    };
  },
  computed: {
    contact() {
      return this.$store.state.contact;
    }
  },
  methods: {
    sendEmail() {
      this.loading = true;
      axios
        .post(
          "/api/sendmail/",
          {
            email: this.email,
            name: this.name,
            message: this.message
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD
            }
          }
        )
        .then(() => {
          this.loading = false;
          this.sent = true;
          this.error = false;
        })
        .catch(() => {
          this.loading = false;
          this.sent = false;
          this.error = true;
        });
    },
    handleNewLine(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
    }
  }
};
</script>

<style lang="scss">
.contact {
  p {
    margin-bottom: var(--lh);
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  form {
    button,
    input,
    textarea {
      display: block;
      box-sizing: border-box;
      width: 100%;
      appearance: none;
      border: 0;
      border-radius: 0;
      border-bottom: 1px solid #aaa;
      padding: calc(0.25 * var(--lh)) calc(0.5 * var(--lh))
        calc(0.4 * var(--lh));
      font-family: "Modern-Aspekt-Regular";
      font-size: var(--fs);
      line-height: 1.2;
      margin-bottom: calc(0.5 * var(--lh));
      transition: color 0.5s, border 0.5s;
      &:placeholder {
        color: #aaa;
      }
      &:focus {
        border-color: black;
        outline: none;
      }
      &:valid {
        border-color: black;
      }
    }
    textarea {
      resize: vertical;
    }
    button,
    button.active {
      width: auto;
      // padding: 0;
      font-family: "Modern-Aspekt-Medium";
      border: none;
      background: white;
      color: #aaa;
      cursor: pointer;
      &:focus {
        border: none;
      }
      &:hover {
        color: black;
      }
    }
  }
}
</style>
